import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { Pagination, PagingParams } from "../models/pagination";
import {
  IBrandData,
  IInverterTypes,
  IProduct,
  IProductCategory,
  ISingleProduct,
  ProductCategory,
  ProductForm,
  UpdateProductVisibility,
  UpdateProductForm,
} from "../models/product";
import { toast } from "react-toastify";
import { router } from "../router/Routes";
import { IImalURl } from "../models/tickets";

export default class ProductStore {
  loading = false;
  loadingInitial = "";
  guidStatus = "";
  pagination: Pagination | null = null;
  pagingParams = new PagingParams();
  //   predicate = new Map().set("all", true);
  currentProduct: ISingleProduct | null = null;
  categories: ProductCategory[] = [];
  categoryList: IProductCategory[] | null = [];
  brandsList: IBrandData[] | null = [];
  inverterTypesList: IInverterTypes[] | null = [];
  vendorProductList: IProduct[] = [];
  vendorApprovedProductList: IProduct[] = [];
  vendorDisapprovedProductList: IProduct[] = [];
  vendorPublishedProductList: IProduct[] = [];
  vendorUnpublishedProductList: IProduct[] = [];
  imageUpload: string[] = [];
  imageUploadIds: string[] = [];

  constructor() {
    makeAutoObservable(this);

    // reaction(
    //   () => this.predicate.keys(),
    //   () => {
    //     this.pagingParams = new PagingParams();
    //     this.activityRegistry.clear();
    //     this.loadActivities();
    //   }
    // );
  }

  setLoading = (x: boolean) => {
    this.loading = x;
  };
  setGuidStatus = (x: string) => {
    this.guidStatus = x;
  };
  setImageUpload = (x: string[]) => {
    this.imageUpload = x;
  };
  getProductCategories = async (params?:PagingParams) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Product.getCategories(params?params: new PagingParams());
      if (response.isSuccessful)
        runInAction(() => {
          this.categoryList = response.data;
        });
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  getProductBrands = async (params?:PagingParams) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Product.getBrands(params?params: new PagingParams());
      if (response.isSuccessful)
        runInAction(() => {
          this.brandsList = response.data;
        });
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  getInverterTypes = async () => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Product.getInverterTypes();
      if (response.isSuccessful)
        runInAction(() => {
          this.inverterTypesList = response.data;
        });
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  getVendorProducts = async (searchTerm : string) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Product.getVendorProducts(searchTerm);
      if (response.isSuccessful) {
        if (response.data) {
          // console.log(response.data)
          runInAction(() => {
            this.vendorProductList = response.data.productItemRequests;
            this.vendorApprovedProductList =
              response.data.productItemRequests.filter((item: { status: string; }) => {
                return item.status === "Approved";
              });
              this.vendorDisapprovedProductList =
              response.data.productItemRequests.filter((item: { status: string; }) => {
                return item.status === "Disapproved" || item.status === "Declined";
              });
            this.vendorPublishedProductList =
              response.data.productItemRequests.filter((item: { status: string; }) => {
                return item.status === "Published";
              });
            this.vendorUnpublishedProductList =
              response.data.productItemRequests.filter((item: { status: string; }) => {
                return item.status === "Unpublished";
              });
          });
        }
      } else toast.info(response.responseMessage);
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  fetchProductAsync = async (id: string) => {
    this.guidStatus = "loading";
    try {
      const response = await agent.Product.getProduct(id);
      // console.log(response)
      if (response.isSuccessful)
        runInAction(() => {
          this.currentProduct = response.data;
          this.imageUpload = response.data.productImages.map((image: { productImageUrl: any; }) => {
            return image.productImageUrl;
          });
          this.imageUploadIds = response.data.productImages.map(
            (image: { productImageId: any; }) => {
              return image.productImageId;
            }
          );
        });
      else {
        toast.info(response.responseMessage);
        router.navigate("/vendor/products");
      }
      // this.guidStatus = "";
      return response;
    } catch (error) {
      this.guidStatus = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  addProduct = async (creds: ProductForm) => {
    this.loading = true;
    try {
      const response = await agent.Product.addProduct(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loading = false));
        return response;
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
        });

      //   router.navigate("/activities");
      //   store.modalStore.closeModal();
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };
  addMultipleProducts = async (creds: ProductForm[]) => {
    this.loading = true;
    try {
      const response = await agent.Product.addMultipleProducts(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loading = false));
        return response;
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
        });

      //   router.navigate("/activities");
      //   store.modalStore.closeModal();
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };

  updateProduct = async (creds: UpdateProductForm) => {
    this.loading = true;
    try {
      const response = await agent.Product.updateProduct(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loading = false));
        return response;
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
        });

      //   router.navigate("/activities");
      //   store.modalStore.closeModal();
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };

  deleteProduct = async (creds: string) => {
    this.loading = true;
    try {
      const response = await agent.Product.removeProduct(creds);
      if (response.isSuccessful) {
        runInAction(() => {
          this.vendorProductList = this.vendorProductList.filter((item) => {
            return item.productId !== creds;
          });
          this.vendorApprovedProductList =
            this.vendorApprovedProductList.filter((item) => {
              return item.productId !== creds;
            });
          this.vendorDisapprovedProductList =
            this.vendorDisapprovedProductList.filter((item) => {
              return item.productId !== creds;
            });
          this.vendorPublishedProductList =
            this.vendorDisapprovedProductList.filter((item) => {
              return item.productId !== creds;
            });
          this.vendorUnpublishedProductList =
            this.vendorUnpublishedProductList.filter((item) => {
              return item.productId !== creds;
            });

          this.loading = false;
        });
        toast.info(response.responseMessage);
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
          // return response;
        });

      return response;
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };

  getUrl = async (creds: IImalURl) => {
    this.loading = true;
    try {
      const response = await agent.Tickets.createUrl(creds.postedFilebase64);
      if (response.isSuccessful) {
        // runInAction(() => (this.loadingInitial = ""));
        return response;
      } else {
        const err = "Couldn't upload image";
        throw err;
      }
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };
  changeProductVisibility = async (creds: UpdateProductVisibility) => {
    this.loading = true;
    try {
      const response = await agent.Product.updateProductVisibility(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loading = false));
        await this.getVendorProducts("");
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };
}
